module.exports = __webpack_public_path__ + "953276e99171d3bd0d051bd9d8621b50.svg";